<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="app-main-content change-charge-verify">
    <div class="tabs-container">
      <el-tabs v-model="activeTabName" type="card" style="width:100%;">
        <el-tab-pane v-if="hasTabJudgeDuty && applyChangeChargeTab === 0" :label="$t('ChangeCharge.tabJudgeDuty')" name="tabJudgeDuty" :lazy="true">
          <tab-change-charge v-if="judgeDutyIsShow && applyChangeChargeTab === 0" :application-status="0" />
        </el-tab-pane>
        <el-tab-pane v-if="hasTabBusinessAudit" :label="$t('ChangeCharge.tabBusinessAudit')" name="tabBusinessAudit" :lazy="true">
          <tab-change-charge v-if="businessAuditIsShow" :application-status="1" />
        </el-tab-pane>
        <el-tab-pane v-if="hasTabManagerReview && applyChangeChargeTab === 1" :label="$t('ChangeCharge.tabManagerReview')" name="tabManagerReview" :lazy="true">
          <tab-change-charge v-if="managerReviewIsShow && applyChangeChargeTab === 1" :application-status="4" />
        </el-tab-pane>
        <el-tab-pane v-if="hasTabJudgeClosed" :label="$t('ChangeCharge.tabJudgeClosed')" name="tabJudgeClosed" :lazy="true">
          <tab-change-charge v-if="judgeClosedIsShow" :application-status="2" />
        </el-tab-pane>
        <el-tab-pane v-if="hasTabAll" :label="$t('ChangeCharge.tabAll')" name="tabAll" :lazy="true">
          <tab-change-charge v-if="allIsShow" :application-status="3" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import TabChangeCharge from '@/views/cargo/v0/Clearing/components/ChangeChargeVerify/tabChangeCharge'
import { cache, cacheName } from '@/utils/cacheManager'

export default {
  name: 'ChangeChargeVerify',
  components: { TabChangeCharge },
  data() {
    return {
      activeTabName: 'tabJudgeDuty',
      hasTabJudgeDuty: this.$checkPermission(['tab_ChangeChargeVerify_tabJudgeDuty']),
      hasTabBusinessAudit: this.$checkPermission(['tab_ChangeChargeVerify_tabBusinessAudit']),
      hasTabJudgeClosed: this.$checkPermission(['tab_ChangeChargeVerify_tabJudgeClosed']),
      hasTabAll: this.$checkPermission(['tab_ChangeChargeVerify_tabAll']),
      hasTabManagerReview: this.$checkPermission(['tab_ChangeChargeVerify_tabManagerReview']),
      judgeDutyIsShowed: false,
      businessAuditIsShowed: false,
      judgeClosedIsShowed: false,
      managerReviewIsShowed: false,
      allIsShowed: false,
      applyChangeChargeTab: 0 // 控制更改费用审核页签显示
    }
  },
  computed: {
    judgeDutyIsShow() {
      if (this.activeTabName === 'tabJudgeDuty' && !this.judgeDutyIsShowed) {
        this.judgeDutyIsShowed = true
      }
      return this.judgeDutyIsShowed
    },
    businessAuditIsShow() {
      if (this.activeTabName === 'tabBusinessAudit' && !this.businessAuditIsShowed) {
        this.businessAuditIsShowed = true
      }
      return this.businessAuditIsShowed
    },
    judgeClosedIsShow() {
      if (this.activeTabName === 'tabJudgeClosed' && !this.judgeClosedIsShowed) {
        this.judgeClosedIsShowed = true
      }
      return this.judgeClosedIsShowed
    },
    managerReviewIsShow() {
      if (this.activeTabName === 'tabManagerReview' && !this.managerReviewIsShowed) {
        this.managerReviewIsShowed = true
      }
      return this.managerReviewIsShowed
    },
    allIsShow() {
      if (this.activeTabName === 'tabAll' && !this.allIsShowed) {
        this.allIsShowed = true
      }
      return this.allIsShowed
    }
  },
  async created() {
    await this.init()
    this.defaultActiveTabName()
  },
  methods: {
    async init() {
      await cache.load(cacheName.CONFIG)
      this.applyChangeChargeTab = Number(cache.config.get('applyChangeChargeTab'))
    },
    defaultActiveTabName() {
      if (this.hasTabJudgeDuty && this.applyChangeChargeTab === 0) {
        this.activeTabName = 'tabJudgeDuty'
      } else if (this.hasTabBusinessAudit) {
        this.activeTabName = 'tabBusinessAudit'
      } else if (this.hasTabJudgeClosed) {
        this.activeTabName = 'tabJudgeClosed'
      } else if (this.hasTabManagerReview && this.applyChangeChargeTab === 1) {
        this.activeTabName = 'tabManagerReview'
      } else if (this.hasTabAll) {
        this.activeTabName = 'tabAll'
      }
    }
  }
}
</script>

<style lang="scss">
</style>
